module.exports = __webpack_public_path__ + "img/terroir-liquify-4-mobile.29d45aab.jpg";